import { Controller, useFormContext } from "react-hook-form";

import { FullWidthSwitch } from "@/features/shared/components/FullWidthSwitch";

import { useProjectDetails } from "../useProjectDetails";

export function TogglesSection() {
  const { control } = useFormContext();
  const { isReadOnly } = useProjectDetails();

  return (
    <div className="bg-bg-primary px-6 mx-6 pt-6">
      <h3 className="text-lg text-text-primary mb-3">Account Toggles</h3>

      <div className="flex flex-col space-y-5">
        <Controller
          control={control}
          name="toggles.isFreeAccount"
          render={({ field: { onChange, value } }) => (
            <FullWidthSwitch
              description="Non-paying account with complete platform access"
              disabled={isReadOnly}
              isSelected={value}
              label="Free account"
              onChange={onChange}
            />
          )}
        />
        <Controller
          control={control}
          name="toggles.isInternalAccount"
          render={({ field: { onChange, value } }) => (
            <FullWidthSwitch
              description="For internal testing only, not counted as active"
              disabled={isReadOnly}
              isSelected={value}
              label="Internal account"
              onChange={onChange}
            />
          )}
        />
        <Controller
          control={control}
          name="toggles.isSunsetShift"
          render={({ field: { onChange, value } }) => (
            <FullWidthSwitch
              description="Indicate this account is on the sunset shift"
              disabled={isReadOnly}
              isSelected={value}
              label="Sunset shift"
              onChange={onChange}
            />
          )}
        />
        <Controller
          control={control}
          name="toggles.isConcierge"
          render={({ field: { onChange, value } }) => (
            <FullWidthSwitch
              description="This account will offer our concierge services"
              disabled={isReadOnly}
              isSelected={value}
              label="Concierge"
              onChange={onChange}
            />
          )}
        />
      </div>
    </div>
  );
}
